import type { RuleEdgeProps } from "../types/edges";
import BaseEdge from "./BaseEdge";

const LoopAfterLastEdge = (props: RuleEdgeProps) => {
	return (
		<BaseEdge
			{...props}
			data={{
				...props.data,
				label: "After Last",
				color: "#7B61FF",
				disableAddButton: true,
			}}
		/>
	);
};

export default LoopAfterLastEdge;
